import IcomoonIcon from "@icons/IcomoonIcon";
import { LoaderStyle } from "./LoaderSpinner";

function Loading(): JSX.Element {
  return (
    <div style={{ height: "100vh" }}>
      <LoaderStyle>
        <IcomoonIcon
          icon="spinner9"
          iconClassName="icon-spin"
          color="#75b9e6"
          size={24}
        />
      </LoaderStyle>
    </div>
  );
}

export default Loading;
